export function deleteAt<T>(index: number, array: T[]): T[] {
  if (index < 0 || index >= array.length) return array

  return [...array.slice(0, index), ...array.slice(index + 1)]
}
